export function getLogoUrl(config, vuetifyDark) {
  const { design } = config;
  if (design) {
    const theme = design["default_theme"];
    const logo = theme === "dark" && vuetifyDark
    ? design["dark_theme_logo"]
    : design["light_theme_logo"];
    return logo
  }
  return config.logo;
}
